import { z } from 'zod/v4';
import { createDefinitionSchema } from '../utils/helpers';

export const graphiteTimeSeriesQueryDefinitionSchema = createDefinitionSchema(
  'GraphiteTimeSeriesQuery',
  z.object({
    query: z.string(),
  })
);

export type GraphiteTimeSeriesQueryDefinition = z.infer<typeof graphiteTimeSeriesQueryDefinitionSchema>;
export type GraphiteQuerySpec = GraphiteTimeSeriesQueryDefinition['spec'];
export type GraphiteTimeSeriesQueryKind = GraphiteTimeSeriesQueryDefinition['kind'];
